import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-673d306a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assertion-set" }
const _hoisted_2 = { class: "list-unstyled" }

import { computed, ref } from 'vue'
import { FuzzyDate } from '@/rd/FuzzyDate'
import { Collapse } from 'bootstrap'
import AssertionRow from './AssertionRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssertionSet',
  props: {
    assertionIds: {},
    baseDate: {},
    dimmedIds: {},
    showCount: { type: Boolean }
  },
  emits: [
  "click",
],
  setup(__props: any, { emit }) {

const props = __props;





const setMemberListRef = ref<HTMLUListElement>()

const isSingletonRef = computed(() => props.assertionIds.length === 1)
const allDimmedRef = computed(() => {
  return props.dimmedIds && props.assertionIds.every(id => props.dimmedIds!.includes(id))
})

function onClickTop(id: string) {
  if (isSingletonRef.value) {
    onClickOne(id)
  }
  else if (setMemberListRef.value) {
    new Collapse(setMemberListRef.value).toggle() // toggles the collapse state
  }
}

function onClickOne(id: string) {
  emit('click', id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.assertionIds.length)
      ? (_openBlock(), _createBlock(AssertionRow, {
          key: 0,
          assertionId: _ctx.assertionIds.at(0),
          baseDate: _ctx.baseDate,
          "no-attrib": "",
          count: _ctx.showCount ? _ctx.assertionIds.length : undefined,
          dimmed: allDimmedRef.value,
          onClick: onClickTop
        }, null, 8, ["assertionId", "baseDate", "count", "dimmed"]))
      : _createCommentVNode("", true),
    (!isSingletonRef.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "setMemberListRef",
          ref: setMemberListRef,
          class: "collapse"
        }, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assertionIds, (id) => {
              return (_openBlock(), _createElementBlock("li", { key: id }, [
                _createVNode(AssertionRow, {
                  assertionId: id,
                  baseDate: _ctx.baseDate,
                  "no-icon": "",
                  indented: "",
                  dimmed: _ctx.dimmedIds?.includes(id),
                  onClick: onClickOne
                }, null, 8, ["assertionId", "baseDate", "dimmed"])
              ]))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})